module.exports = __webpack_public_path__ + "img/call.e4ec9820.png";